"use client";

import { c as _c } from "react/compiler-runtime";
import { CatalogCardDefinition, CatalogCardFrame, CatalogItemHeading, CatalogTileProps, PriceFooter, TypeCorner } from "../components/catalog-card-primitives";
import React from "react";
import { FiCalendar } from "react-icons/fi";
const ServiceMotif: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><div className="absolute -bottom-24 -right-20 h-64 w-64 rounded-full border border-primary/10" /><div className="absolute -bottom-16 -right-12 h-44 w-44 rounded-full border border-primary/10" /><div className="absolute right-6 top-7 h-12 w-14 rounded-lg border border-primary/15" /><div className="absolute right-9 top-10 h-1 w-8 rounded-full bg-primary/15" /><div className="absolute right-9 top-[3.75rem] h-1 w-6 rounded-full bg-primary/10" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const serviceCard: CatalogCardDefinition = {
  label: "Service",
  Icon: FiCalendar,
  visual: {
    background: "bg-[radial-gradient(circle_at_18%_0%,rgb(var(--primary)_/_0.16),transparent_56%)] bg-background",
    Motif: ServiceMotif
  },
  eyebrow: item => item.category ?? "Service"
};
export const ServiceTile: React.FC<CatalogTileProps> = t0 => {
  const $ = _c(23);
  const {
    item,
    onSelect,
    compact: t1,
    className,
    opensDialog,
    placement,
    quantity,
    onQuantityChange
  } = t0;
  const compact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== compact) {
    t2 = <TypeCorner definition={serviceCard} compact={compact} />;
    $[0] = compact;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== item) {
    t3 = <CatalogItemHeading item={item} definition={serviceCard} />;
    $[2] = item;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = Boolean(onSelect);
  let t5;
  if ($[4] !== item || $[5] !== onQuantityChange || $[6] !== quantity || $[7] !== t4) {
    t5 = <PriceFooter item={item} interactive={t4} quantity={quantity} onQuantityChange={onQuantityChange} />;
    $[4] = item;
    $[5] = onQuantityChange;
    $[6] = quantity;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="relative flex h-full flex-1 flex-col">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== compact || $[14] !== item || $[15] !== onQuantityChange || $[16] !== onSelect || $[17] !== opensDialog || $[18] !== placement || $[19] !== quantity || $[20] !== t2 || $[21] !== t6) {
    t7 = <CatalogCardFrame item={item} onSelect={onSelect} compact={compact} className={className} opensDialog={opensDialog} placement={placement} quantity={quantity} onQuantityChange={onQuantityChange} definition={serviceCard} corner={t2}>{t6}</CatalogCardFrame>;
    $[12] = className;
    $[13] = compact;
    $[14] = item;
    $[15] = onQuantityChange;
    $[16] = onSelect;
    $[17] = opensDialog;
    $[18] = placement;
    $[19] = quantity;
    $[20] = t2;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};